import TutorReplacementPage from './TutorReplacementPage';

// Tutor Replacement Count, by CRO (the page and its rules: TutorReplacementPage.jsx).
const TutorReplacementCountDashboard = () => <TutorReplacementPage mode="cro" />;

export default TutorReplacementCountDashboard;
